import React from "react";
import PropTypes from 'prop-types';

import { FieldValue, serverTimestamp } from "firebase/firestore";
import { db } from "../../lib/firebaseCompat";

import { useTooltip } from "../../hooks/useTooltip";

export default function EstimateTdUnarchive({orgId, docId}) {
  const ref = useTooltip();

  const handleUnarchive = async (evt) => {
    if (!orgId) {
      return;
    }
    const doc = db
      .collection("organizations")
      .doc(orgId)
      .collection("estimates")
      .doc(docId);

    try {
      await doc.update({
        archived: false,
        updatedAt: serverTimestamp(),
      });
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <td>
      <i
        className="material-icons cursor-pointer secondary-text-color"
        data-tooltip="Unarchive Estimate"
        data-position="left"
        ref={ref}
        onClick={handleUnarchive}
      >
        unarchive
      </i>
    </td>
  );
}

EstimateTdUnarchive.propTypes = {
  orgId: PropTypes.string.isRequired,
  docId: PropTypes.string.isRequired,
}
